import { DirectUploadMedia } from "libs/directUpload";
import { Admin, useProfile } from "modules/common";
import { useGetStaffManagersList } from "modules/staff";
import { useMemo } from "react";

/**
 * Resolves an admin id -> avatar image. The audit row only carries the admin's
 * name snapshot, so we look images up from the moderator directory plus the
 * current user. Admins not in that set fall back to a placeholder avatar.
 * The underlying queries are react-query cached, so calling this per row issues
 * a single request.
 */
const useAdminImageMap = () => {
  const { user } = useProfile({ enabled: false });
  const { staffManagersList } = useGetStaffManagersList(
    { page: 1, take: 50 },
    { onError: () => undefined }
  );

  return useMemo(() => {
    const map = new Map<string, DirectUploadMedia | null>();

    staffManagersList?.forEach((admin) => {
      map.set(admin.id, admin.image ?? null);
    });

    const profile = user as Partial<Admin>;
    if (profile?.id) map.set(profile.id, profile.image ?? null);

    return map;
  }, [staffManagersList, user]);
};

export default useAdminImageMap;
